import { useLocalization } from '@magicdoorinc/ui';
import { bankAccountConnectionStatusDict } from '~/utils/constant';
import type { FilterOwner } from './context';
import type { FilterValue } from './types';
import type { FilterItem } from '@magicdoorinc/ui';

export const useConnectionStatusFilter = <T extends FilterValue>(owner: FilterOwner<T>, key: keyof T, label: string) => {
  const { t } = useLocalization();

  const options = [{ label: t('All'), value: 'All' }, ...bankAccountConnectionStatusDict.getOptions()];

  return {
    type: 'select',
    key,
    label,
    options,
  } as FilterItem<T>;
};
